// AbSupplierList — Top-Lieferanten der letzten 7 Tage als horizontale Balken.

import React from 'react';
import { Card, SectionTitle } from '../ui';

const AbSupplierList = ({ suppliers, isDarkMode, t }) => {
  const data = Array.isArray(suppliers) ? suppliers.slice(0, 6) : [];
  const textMuted = isDarkMode ? 'text-white/40' : 'text-slate-400';

  return (
    <Card isDarkMode={isDarkMode}>
      <SectionTitle isDarkMode={isDarkMode} right={<span className={`text-[11px] ${textMuted}`}>{t('ab.shell.suppliersSubtitle')}</span>}>
        {t('ab.shell.suppliersTitle')}
      </SectionTitle>
      {data.length === 0 ? (
        <p className={`text-sm ${textMuted}`}>{t('ab.shell.suppliersEmpty')}</p>
      ) : (
        <div className="space-y-2.5">
          {(() => {
            const max = Math.max(1, ...data.map((s) => s.count || 0));
            return data.map((s) => (
              <div key={s.supplierId || '—'} className="flex items-center gap-2.5">
                <span className={`text-xs w-24 flex-shrink-0 truncate ${isDarkMode ? 'text-white/70' : 'text-slate-600'}`}>
                  {s.supplierName || s.supplierId || t('ab.supplierUnknown')}
                </span>
                <div className={`flex-1 h-2 rounded-full overflow-hidden ${isDarkMode ? 'bg-white/8' : 'bg-slate-100'}`}>
                  <div className={`h-full rounded-full ${isDarkMode ? 'bg-indigo-400' : 'bg-indigo-500'}`} style={{ width: `${((s.count || 0) / max) * 100}%` }} />
                </div>
                <span className={`text-xs tabular-nums w-6 text-right flex-shrink-0 ${isDarkMode ? 'text-white/50' : 'text-slate-500'}`}>{s.count || 0}</span>
              </div>
            ));
          })()}
        </div>
      )}
    </Card>
  );
};

export default AbSupplierList;
